import React, { createContext, useContext, useState, ReactNode } from "react"

interface Wallet {
  publicKey: string
  balance?: string
  identifier: string
}

// Define the structure of the public keys response
interface PublicKeysResponse {
  [identifier: string]: {
    publicKey: string
    balance?: string
  }
}

interface AppContextType {
  wallets: PublicKeysResponse | null // Use the PublicKeysResponse type
  setWallets: React.Dispatch<React.SetStateAction<PublicKeysResponse | null>>
  activeWallet: Wallet | null
  setActiveWallet: React.Dispatch<React.SetStateAction<Wallet | null>>
}

const AppContext = createContext<AppContextType | undefined>(undefined)

export const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [wallets, setWallets] = useState<PublicKeysResponse | null>(null)
  const [activeWallet, setActiveWallet] = useState<Wallet | null>(null)

  return <AppContext.Provider value={{ wallets, setWallets, activeWallet, setActiveWallet }}>{children}</AppContext.Provider>
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider")
  }
  return context
}
